// @ts-strict-ignore
import { useState } from 'react'
import { logSentryErrorAndGetTraceId } from '@node-space/utils'
import { BaseErrorResponse } from 'types/beneficiaries'
import { MappedErrorMessageState } from 'types/errors'

export const useMappedErrorMessage = () => {
  const initialRequestError: MappedErrorMessageState = {
    show: false,
  }

  const [requestError, setRequestError] = useState<MappedErrorMessageState>(initialRequestError)

  const resetRequestError = () => setRequestError(initialRequestError)

  const handleRequestError = (
    error: BaseErrorResponse,
    endpoint: string,
    mutationName: string,
    showErrorsList?: boolean
  ) => {
    const sentryTraceId = logSentryErrorAndGetTraceId(
      `Failed API request to ${endpoint} with status ${error?.status}`,
      error,
      { function: mutationName }
    )
    const ErrorMessages = showErrorsList && error?.data?.details?.errors
    setRequestError({
      errorCode: error?.status,
      sentryTraceId,
      show: true,
      ...(ErrorMessages && { ErrorMessages }),
    })
  }

  return {
    initialRequestError,
    requestError,
    setRequestError,
    resetRequestError,
    handleRequestError,
  }
}
